export enum IMessageType {
  INCOMING = "INCOMING",
  OUTGOING = "OUTGOING",
}

export interface IFetchUserDetailsParams {
  user_ids: string[];
  doctor_ids: string[];
  ip_dash_id: string[];
  device_token_user_id: string;
  appointment_ids?: string[];
  member_ids?: string[];
}

export enum MESSAGE_TYPE {
  TEXT,
  AUDIO,
  ATTACHMENT,
  VIDEO_CALL,
  ORDER_MEDICINE,
  CONSULTATION_END,
  DISCHARGE,
  CANCELLED,
}

export enum CONVERSATION_STATUS {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  COMPLETED = "COMPLETED",
  DISABLED = "DISABLED",
  RESOLVED = "RESOLVED",
  CANCELLED = "CANCELLED",
  DISCHARGED = "DISCHARGED",
}

export enum CONVERSATION_TYPE {
  APPOINTMENT = "APPOINTMENT",
  IN_PATIENT = "IN_PATIENT",
  SUPPORT = "SUPPORT",
}

export interface Message {
  uniqueId: string;
  timestamp: number;
  sender_id: string;
  isSeen: boolean;
  mentions?: Array<{ userId: string }>;
  type?: number;
  [key: string]: any;
}

export interface Channel {
  uniqueId: string;
  lastMessage: {
    internal?: Message | null;
    patient?: Message | null;
  };
  unReadMessageCount: number;
  users: {
    staff_members: string[];
    family_members: string[];
  };
  [key: string]: any;
}

export enum CHAT_TYPE {
  CHAT,
  MEDIA,
  RECORDS,
}

export enum CHAT_LIST_TYPE {
  INTERNAL,
  PATIENT,
}
export interface UseFirebaseMessagingProps {
  chatListType: CHAT_LIST_TYPE;
}

export enum ITabIndex {
  APPOINTMENTS,
  IN_PATIENTS,
}

export enum IChatSubCollection {
  INTERNAL = "internal",
  PATIENT = "patient",
}

interface IUnreadCategory {
  mentionCount: number;
  unreadCount: number;
}

export interface IGlobalUnreadCounts {
  appointment: IUnreadCategory;
  inPatient: IUnreadCategory;
}

export interface UseFirebaseMessagingReturn {
  listType: CHAT_LIST_TYPE;
  messages: Message[];
  patientChatMediaList: Message[];
  channelList: Channel[];
  enrichedChannelList: Channel[];
  channelId: string | null;
  handleList: (list: CHAT_LIST_TYPE) => void;
  handleChannel: (channelId: string) => void;
  handleSendMessage: (message: Record<string, any>) => Promise<void>;
  markMessageAsRead: (
    messageId: string,
    channelID: string,
    subcollection: IChatSubCollection
  ) => Promise<void>;
  markAllMessagesAsRead: (
    channelID: string,
    subcollection: IChatSubCollection
  ) => Promise<void>;
  removeMemberFromChat: (familyMemberId: string) => Promise<void>;
  updateChatStatusOrFavorite: (
    channelId: string,
    isFavorite: boolean,
    isChatEnabled: boolean
  ) => Promise<void>;
  supportChat: Channel;
  handleDocumentId: (id: string) => void;
  paginatedDocs: Channel[];
  isLoadingMore: boolean;
  hasMoreDocs: boolean;
  fetchPaginatedConversations: (
    conversationType: CONVERSATION_TYPE,
    initialFetch?: boolean
  ) => Promise<any[]>;
  setSwitchChatTab: (tab: ITabIndex) => void;
  fetchConversationById: (id: string) => {};
  globalUnreadCounts: IGlobalUnreadCounts;
  isLoadingMessages: boolean;
}

export enum CHAT_CARD_TYPE {
  CHAT = "CHAT",
  SUPPORT = "SUPPORT",
}
